/**
 * @generated SignedSource<<683a6e115f329c9fd35acacd9ad3d0af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QueueSidebarPoolIdsFragment$data = {
  readonly agentPoolsRest: {
    readonly agentPool: ReadonlyArray<{
      readonly rawId: number | null | undefined;
    }> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "QueueSidebarPoolIdsFragment";
};
export type QueueSidebarPoolIdsFragment$key = {
  readonly " $data"?: QueueSidebarPoolIdsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"QueueSidebarPoolIdsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QueueSidebarPoolIdsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AgentPools",
      "kind": "LinkedField",
      "name": "agentPoolsRest",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AgentPoolRest",
          "kind": "LinkedField",
          "name": "agentPool",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rawId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "aebd8bc3e1b10030ccdfe80b3810f220";

export default node;
